import { OpPatch } from "json-patch";
import { Axios } from "../../Axios";
import { TypeEnfermidade } from "../../../Models/Domain/Saude/Enfermidade";

export interface IFiltro {
    codigo?: number,
    ativo?: boolean,
    nome?: string,
    descricao?: string
}

export class EnfermidadeService {
    public static listar(filtro?: IFiltro){
        return Axios.get<TypeEnfermidade[]>(`quiron/saude/enfermidade`, {params: filtro});
    }

    public static atualizar(payload: TypeEnfermidade){
        return Axios.put<void>(`quiron/saude/enfermidade`, payload);
    }

    public static atualizarComPatch(codigo: number, payload: OpPatch){
        return Axios.patch<void>(`quiron/saude/enfermidade/${codigo}`, payload);
    }

    public static inserir(payload: TypeEnfermidade){
        return Axios.post<void>(`quiron/saude/enfermidade`, payload);
    }

    public static desativar(codigo: number){
        return Axios.patch<void>(`quiron/saude/enfermidade/${codigo}/desativar`);
    }

    public static ativar(codigo: number){
        return Axios.patch<void>(`quiron/saude/enfermidade/${codigo}/ativar`);
    }
}